import { IInputMultiSelectFiltersMeta } from 'Mri.Web.Common';
import * as React from 'react';
import { BsBuilding } from '@react-icons/all-files/bs/BsBuilding';
import { BsCalendar } from '@react-icons/all-files/bs/BsCalendar';
import { BsFileEarmark } from '@react-icons/all-files/bs/BsFileEarmark';
import { BsFileEarmarkDiff } from '@react-icons/all-files/bs/BsFileEarmarkDiff';
import { BsPeople } from '@react-icons/all-files/bs/BsPeople';
import { BsFunnelFill } from '@react-icons/all-files/bs/BsFunnelFill';
import { BsColumnsGap } from '@react-icons/all-files/bs/BsColumnsGap';
import { BsGrid3X3GapFill } from '@react-icons/all-files/bs/BsGrid3X3GapFill';
import { BsServer } from '@react-icons/all-files/bs/BsServer';
import { BsTools } from '@react-icons/all-files/bs/BsTools';
import { AccountsFilter } from './AccountsFilter';
import { CitiesFilter } from './CitiesFilter';
import { ContractsFilter } from './ContractsFilter';
import { CountriesFilter } from './CountriesFilter';
import { DisplayEventFilterDropdown } from './DisplayEventFilterDropdown';
import { DisplayGroupsFilter } from './DisplayGroupsFilter';
import { DisplayListViewModel } from './DisplayListViewModel';
import { NocServersFilter } from './NocServersFilter';
import { PartDefinitionsFilter } from './PartDefinitionsFilter';
import { ContractOptionsFilter } from './ContractOptionsFilter';
import { StateOrProvincesFilter } from './StateOrProvincesFilter';
import { WhereFilter } from './WhereFilter';
import { BsMap } from '@react-icons/all-files/bs/BsMap';
import { ServiceLevelsFilter } from './ServiceLevelsFilter';
import { BsClipboard } from '@react-icons/all-files/bs/BsClipboard';
import { SoftwareVersionsFilter } from './SoftwareVersionsFilter';
import { BsLightning } from '@react-icons/all-files/bs/BsLightning';

export const displayFilters: readonly IInputMultiSelectFiltersMeta<DisplayListViewModel>[] = [
    {
        id: 'accounts',
        title: 'Accounts',
        icon: <BsBuilding style={{ fontSize: 18 }} />,
        shouldRender: vm => vm.displayFilter.accounts != undefined && vm.displayFilter.accounts.length > 0,
        render: props => <AccountsFilter key="accounts" {...props} />,
    },
    {
        id: 'contracts',
        title: 'Contracts',
        icon: <BsFileEarmark style={{ fontSize: 18 }} />,
        shouldRender: vm => vm.displayFilter.contracts != undefined && vm.displayFilter.contracts.length > 0,
        render: props => <ContractsFilter key="contracts" {...props} />,
    },
    {
        id: 'nocServers',
        title: 'Servers',
        icon: <BsServer style={{ fontSize: 18 }} />,
        shouldRender: vm => vm.displayFilter.nocServers != undefined && vm.displayFilter.nocServers.length > 0,
        render: props => <NocServersFilter key="nocServers" {...props} />,
    },
    {
        id: 'currentSoftwareVersions',
        title: 'Software Versions',
        icon: <BsLightning style={{ fontSize: 18 }} />,
        shouldRender: vm => vm.displayFilter.currentSoftwareVersions != undefined && vm.displayFilter.currentSoftwareVersions.length > 0,
        render: props => <SoftwareVersionsFilter key="currentSoftwareVersions" {...props} />,
    },
    {
        id: 'partDefinitions',
        title: 'Part Numbers',
        icon: <BsFileEarmarkDiff style={{ fontSize: 18 }} />,
        shouldRender: vm => vm.displayFilter.partDefinitions != undefined && vm.displayFilter.partDefinitions.length > 0,
        render: props => <PartDefinitionsFilter key="partDefinitions" {...props} />,
    },
    {
        id: 'cities',
        title: 'Cities',
        icon: <BsPeople style={{ fontSize: 18 }} />,
        shouldRender: vm => vm.displayFilter.cities != undefined && vm.displayFilter.cities.length > 0,
        render: props => <CitiesFilter key="cities" {...props} />,
    },
    {
        id: 'stateOrProvince',
        title: 'State Or Province',
        icon: <BsMap style={{ fontSize: 18 }} />,
        shouldRender: vm => vm.displayFilter.stateOrProvinces != undefined && vm.displayFilter.stateOrProvinces.length > 0,
        render: props => <StateOrProvincesFilter key="stateOrProvince" {...props} />,
    },
    {
        id: 'countries',
        title: 'Countries',
        icon: <BsColumnsGap style={{ fontSize: 18 }} />,
        shouldRender: vm => vm.displayFilter.countries != undefined && vm.displayFilter.countries.length > 0,
        render: props => <CountriesFilter key="countries" {...props} />,
    },
    {
        id: 'displayGroups',
        title: 'Display Groups',
        icon: <BsGrid3X3GapFill style={{ fontSize: 18 }} />,
        shouldRender: vm => vm.displayFilter.displayGroups != undefined && vm.displayFilter.displayGroups.length > 0,
        render: props => <DisplayGroupsFilter key="displayGroups" {...props} />,
    },
    {
        id: 'contractOptions',
        title: 'Contract Options',
        icon: <BsTools style={{ fontSize: 18 }} />,
        shouldRender: vm => vm.displayFilter.contractOptions != undefined && vm.displayFilter.contractOptions.length > 0,
        render: props => <ContractOptionsFilter key="contractOptions" {...props} />,
    },
    {
        id: 'serviceLevels',
        title: 'Contract Service Levels',
        icon: <BsClipboard style={{ fontSize: 18 }} />,
        shouldRender: vm => vm.displayFilter.contractServiceLevels != undefined && vm.displayFilter.contractServiceLevels.length > 0,
        render: props => <ServiceLevelsFilter key="serviceLevels" {...props} />,
    },
    {
        id: 'displayEventFilter',
        title: 'Events',
        icon: <BsCalendar style={{ fontSize: 18 }} />,
        shouldRender: vm => vm.displayEventFilter != undefined,
        render: props => <DisplayEventFilterDropdown key="displayEventFilter" {...props} />,
    },
    {
        id: 'filters',
        title: 'Filters',
        icon: <BsFunnelFill style={{ fontSize: 18 }} />,
        shouldRender: vm => vm.where?.length || vm.displayFilter.active != true,
        render: props => <WhereFilter key="filters" {...props} />,
    },
];
